const TEMPLATE_CAPABLE_WHATSAPP_PROVIDERS = [
  'default',
  'whatsapp_cloud',
  'ycloud',
];

export const isTemplateCapableWhatsappInbox = inbox => {
  if (inbox?.channel_type !== 'Channel::Whatsapp') return false;

  const provider = inbox.provider || inbox.channel?.provider;
  return TEMPLATE_CAPABLE_WHATSAPP_PROVIDERS.includes(provider);
};
